import React from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import styled from 'styled-components'

import { primary } from 'styles/colors'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  align-self: stretch;
  margin: 0 6px;

  &:last-child {
    margin-right: 18px;
  }

  @media (min-width: 400px) {
    margin: 0 10px;

    &:last-child {
      margin-right: 30px;
    }
  }
`

const A = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: white;
  white-space: nowrap;
  padding: 6px;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }

  &.active::after {
    content: '';
    height: 6px;
    width: 70px;
    background-color: ${primary};
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
  }

  @media (min-width: 400px) {
    font-size: 16px;
    padding: 10px;
  }
`

const Button = styled.button`
  background-color: transparent;
  border: none;
  color: white;
  font-weight: 300;
  cursor: pointer;
  font-size: 14px;
  padding: 6px;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: 400px) {
    font-size: 16px;
    padding: 10px;
  }
`

const Text = styled.span``

const MenuItem = ({ exact, text, link, onClick }) =>
  link ? (
    <Wrapper>
      <A exact={exact} to={link}>
        <Text>{text}</Text>
      </A>
    </Wrapper>
  ) : (
    <Wrapper>
      <Button onClick={onClick}>{text}</Button>
    </Wrapper>
  )

export default withRouter(MenuItem)



// WEBPACK FOOTER //
// ./src/components/Header/MenuItem.js